import React from 'react';
import { Label } from 'semantic-ui-react'

const LabelWithCount = ({ label, count, labelClass }) => {
    return (
        <React.Fragment>
            {label} &nbsp;
            {count && count !== 0 ?
                <Label style={{
                    letterSpacing: ".8px",
                }} className={labelClass}>
                    <span
                        style={{ fontSize: "9px" }}>
                        {count}
                    </span>
                </Label> : null
            } </React.Fragment>
    )
}

export default LabelWithCount;


//<LabelWithCount label="" count={} />